import { render } from "./SearchTag.vue?vue&type=template&id=064b8dc4&scoped=true"
import script from "./SearchTag.vue?vue&type=script&lang=js"
export * from "./SearchTag.vue?vue&type=script&lang=js"

import "./SearchTag.vue?vue&type=style&index=0&id=064b8dc4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-064b8dc4"]])

export default __exports__